import React from 'react';

const EnquirySpecification: React.FC = () => {
  return (
    <h1>This page is under construction</h1>
  );
};

export default EnquirySpecification;
